<script lang="ts" setup>
import { useAppendCarrotQuest } from '@/composables/useAppendCarrotQuest'
import { useAppMetaInfo } from '@/composables/useAppMetaInfo'

const { meta } = useAppMetaInfo()
const { $metrics } = useNuxtApp()

onMounted(() => {
  // Загружаем CarrotQuest
  useAppendCarrotQuest()

  // Запуск приложения или сайта
  $metrics?.eventSendGoal({ ym: 'app_opened' })
})
</script>

<template>
  <app-root>
    <VitePwaManifest />
    <Meta
      v-for="info in meta"
      :key="info.name"
      :name="info.name"
      :content="info.content"
    />

    <NuxtLoadingIndicator color="#ff5044" />

    <NuxtLayout>
      <NuxtPage class="page--container" />
    </NuxtLayout>
  </app-root>
</template>

<style lang="scss">
body {
  box-sizing: border-box;
  font-family: 'Raleways', verdana, sans-serif;
}
</style>
